/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { FaqReqSearch } from '../models/faq-req-search';
import { FaqResSearch } from '../models/faq-res-search';

@Injectable({ providedIn: 'root' })
export class FaqService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFaqQueryPost()` */
  static readonly ApiFaqQueryPostPath = '/api/faq/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFaqQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiFaqQueryPost$Response(
    params?: {
      body?: FaqReqSearch
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FaqResSearch>> {
    const rb = new RequestBuilder(this.rootUrl, FaqService.ApiFaqQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FaqResSearch>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFaqQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiFaqQueryPost(
    params?: {
      body?: FaqReqSearch
    },
    context?: HttpContext
  ): Observable<FaqResSearch> {
    return this.apiFaqQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FaqResSearch>): FaqResSearch => r.body)
    );
  }

}
